import LELogger from './util/logger';
import { submitLead } from './submit_lead';
import { getDefaultLeadsFormData } from './default_leads_form_data';
import { sendLeadFormHeapEvents } from './form_analytics';
import { EventNameTypes, makeSegmentTrackCall } from './analytics';

export const loadDrift = () => {
  // From drift.js snippet (DO NOT MODIFY)
  /* eslint-disable */
  !(function() {
    var t;
    if (((t = window.driftt = window.drift = window.driftt || []), !t.init))
      return t.invoked
        ? void (window.console && console.error && console.error('Drift snippet included twice.'))
        : ((t.invoked = !0),
          (t.methods = ['identify', 'config', 'track', 'reset', 'debug', 'show', 'ping', 'page', 'hide', 'off', 'on']),
          (t.factory = function(e) {
            return function() {
              var n;
              return (n = Array.prototype.slice.call(arguments)), n.unshift(e), t.push(n), t;
            };
          }),
          t.methods.forEach(function(e) {
            t[e] = t.factory(e);
          }),
          (t.load = function(t) {
            var e, n, o, i;
            (e = 3e5),
              (i = Math.ceil(new Date() / e) * e),
              (o = document.createElement('script')),
              (o.type = 'text/javascript'),
              (o.async = !0),
              (o.crossorigin = 'anonymous'),
              (o.src = 'https://js.driftt.com/include/' + i + '/' + t + '.js'),
              (n = document.getElementsByTagName('script')[0]),
              n.parentNode.insertBefore(o, n);
          }));
  })();
  /* eslint-enable */
};

const leadSourceDetail = 'Drift Email';
let emailSubmitted = false;

const log = {
  debug() {}
};

function trackChatActivity(data) {
  makeSegmentTrackCall(EventNameTypes.chatActivity, data);
}

function drift_onWelcomeMessageOpen() {
  log.debug('Welcome Message - Opened!');
  trackChatActivity({
    label: 'Welcome Message - Opened'
  });
}

function drift_onWelcomeMessageClose() {
  log.debug('Welcome Message - Closed!');
  trackChatActivity({
    label: 'Welcome Message - Closed'
  });
}

function drift_onAwayMessageOpen() {
  log.debug('Away Message - Opened!');
  trackChatActivity({
    label: 'Away Message - Opened'
  });
}

function drift_onAwayMessageClose() {
  log.debug('Away Message - Closed!');
  trackChatActivity({
    label: 'Away Message - Closed'
  });
}

function drift_onCampaignOpen({ campaignId }) {
  log.debug('Campaign - Opened!');
  trackChatActivity({
    label: 'Campaign - Opened',
    campaignId
  });
}

function drift_onCampaignDismiss(event) {
  log.debug('Campaign - Dismissed!');
  trackChatActivity({
    label: 'Campaign - Dismissed',
    ...event.data
  });
}

function drift_onCampaignClick(event) {
  log.debug('Campaign - CTA Clicked!');
  trackChatActivity({
    label: 'Campaign - CTA Clicked',
    ...event.data
  });
}

function drift_onCampaignSubmit(event) {
  log.debug('Campaign - Submit!');
  trackChatActivity({
    label: 'Campaign - Submit',
    ...event.data
  });
}

function drift_onStartConversation(event) {
  log.debug('Started a new conversation!', event);
  trackChatActivity({
    label: 'Start Conversation',
    ...event.data
  });
}

function drift_onSidebarOpen(event) {
  trackChatActivity({
    label: 'Sidebar Open',
    ...event.data
  });
}

function drift_onSidebarClose(event) {
  trackChatActivity({
    label: 'Sidebar Close',
    ...event.data
  });
}

function drift_onMessageSent(event) {
  log.debug('User replied to conversation!', event);
  trackChatActivity({
    label: 'Message Sent',
    ...event.data
  });
}

function drift_onMessage(event) {
  log.debug('User received a message!', event);
  trackChatActivity({
    label: 'Message',
    ...event.data
  });
}

async function drift_onEmailCapture(event) {
  if (!emailSubmitted) {
    try {
      await submitLeadForm(event);
    } catch (err) {
      handleSubmitLeadFormError(err);
    }
  }
}

async function submitLeadForm() {
  emailSubmitted = true;
  const defaultParams = await getDefaultLeadsFormData(leadSourceDetail);
  const formParams = {
    ...defaultParams,
    email: event.data.email,
    submission_type: 'email'
  };

  await submitLead(formParams);

  sendLeadFormHeapEvents(formParams, leadSourceDetail);

  log.debug('Email captured and lead submitted!');
}

function handleSubmitLeadFormError(err) {
  emailSubmitted = false;

  const logMsg = {
    ...err,
    message: 'Failed to submit Drift Email Lead'
  };
  // in case it's an Error obj
  if (err.message) {
    logMsg.err = err.message;
  }
  LELogger.error(logMsg);
}

function drift_onSchedulingRequestMeeting(event) {
  log.debug('user wants to schedule a meeting!', event);
  trackChatActivity({
    label: 'Schedule Request',
    ...event.data
  });
}

function drift_onSchedulingMeetingBooked(event) {
  log.debug('User scheduled a meeting!', event);
  trackChatActivity({
    label: 'Schedule Booked',
    ...event.data
  });
}

export function bindDriftEventHandlers() {
  const drift = window.drift;

  // Welcome Message Events
  drift.on('welcomeMessage:open', drift_onWelcomeMessageOpen);
  drift.on('welcomeMessage:close', drift_onWelcomeMessageClose);

  // Away Message Events
  drift.on('awayMessage:open', drift_onAwayMessageOpen);
  drift.on('awayMessage:close', drift_onAwayMessageClose);

  // Campaign Events
  drift.on('campaign:open', drift_onCampaignOpen);
  drift.on('campaign:dismiss', drift_onCampaignDismiss);
  drift.on('campaign:click', drift_onCampaignClick);
  drift.on('campaign:submit', drift_onCampaignSubmit);

  // Conversation Events
  drift.on('startConversation', drift_onStartConversation);

  // Sidebar Handling
  drift.on('sidebarOpen', drift_onSidebarOpen);
  drift.on('sidebarClose', drift_onSidebarClose);

  // Message Events
  drift.on('message:sent', drift_onMessageSent);
  drift.on('message', drift_onMessage);

  // Email Capture Events
  drift.on('emailCapture', drift_onEmailCapture);

  // Scheduling Events
  drift.on('scheduling:requestMeeting', drift_onSchedulingRequestMeeting);
  drift.on('scheduling:meetingBooked', drift_onSchedulingMeetingBooked);
}
